import { Badge, IconButton } from "@mui/material"
import { VerticalSplit } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"

import "./style.scss"

const DUPLICATE_VIEW_TOOLTIP = "Duplicate & Edit view"

interface DuplicateViewButtonProps {
  onClick: () => void
  disabled?: boolean
}

export default function DuplicateViewButton({ onClick, disabled }: DuplicateViewButtonProps) {
  return (
    <OPTooltip title={DUPLICATE_VIEW_TOOLTIP}>
      <span>
        <IconButton
          className="column-button"
          onClick={onClick}
          disabled={disabled}
          aria-label={DUPLICATE_VIEW_TOOLTIP}
        >
          <Badge
            className="duplicate-view-button-badge"
            overlap="circular"
            badgeContent="*"
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <VerticalSplit />
          </Badge>
        </IconButton>
      </span>
    </OPTooltip>
  )
}
